import { useContext } from 'react'
import { HagerBridgePermissionContext, HagerBridgePermissionContextValue } from '../providers/HagerBridgePermissionContext'

/**
 * Helper function to unify import of useContext and HagerBridgePermissionContext so that we can import a single
 * hook and call it wherever permissions for targeting HagerBridge service are required.
 */
export const useHagerBridgePermissions = (): HagerBridgePermissionContextValue => {
  return useContext(HagerBridgePermissionContext)
}
